var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"favourite-button-wrapper"},[_c('FavouriteButton',{attrs:{"item-id":_vm.itemId,"item-name":_vm.itemName,"favourites-group":_vm.favouritesGroup}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }